import { addDays, isEqual } from 'date-fns'
import { legacyParse } from '@date-fns/upgrade/v2'
import { EventLite, StreamListItemLite } from '@flocasts/flosports30-types/dist/watch'
import { FloEvent } from '@flocasts/flosports30-types/dist/entity'
import { LiveEventStatus } from '../events.enum'

export enum EventCTAText {
  Replay = 'Replay',
  Replays = 'Replays',
  Watch = 'Watch',
  WatchLive = 'Watch Live'
}

/**
 * Checks if the live event is "between days".
 * @todo Until INTERDAY status is available in API, those events currently
 *       return PRE-AIR status.
 */
export function isInterday(nextStartTime: string | undefined | null, status: string, startTime: string): boolean {
  return (
    (nextStartTime &&
      status === LiveEventStatus.PreAir &&
      !isEqual(legacyParse(startTime), legacyParse(nextStartTime))) === true
  )
}

// TODO: This is a dupe with...
// 1) getEventVideosUrl() in events/functions.ts
// 2) getEventVideosUrl() in event-watch-link.directive
export const getEventVideosUrlTimeline = (event: FloEvent, eventCtaText: string) => {
  if (!!event.live_event) {
    switch (eventCtaText) {
      case EventCTAText.WatchLive:
        return `/live/${event.live_event.id}`
      case EventCTAText.Watch:
        return `/live/${event.live_event.id}`
      case EventCTAText.Replay:
        return `${event.slug_uri}/videos`
      case EventCTAText.Replays:
        return `${event.slug_uri}/videos`
      default:
        return false
    }
  } else {
    return false
  }
}

export const getEventStartDateTimeline = (event: FloEvent) =>
  legacyParse((event.live_event && event.live_event.start_date_time) || event.start_date_time)

export const getEventEndDateTimeline = (event: FloEvent) =>
  legacyParse((event.live_event && event.live_event.end_date_time) || event.end_date_time)

export const mapNumberOfDaysEndDateTimeline = (event: FloEvent) => {
  return addDays(getEventStartDateTimeline(event), (event.number_of_days || 1) - 1)
}

export const getBadgeTextByEventStatus = (event: EventLite): string | null => {
  if (!!event.live_event) {
    switch (event.live_event.status) {
      case LiveEventStatus.Live:
        const streams = {
          exist: event.live_event.stream_list,
          count: checkForActiveStreams(event.live_event.stream_list)
        }
        return streams.exist && ((streams.count > 1 && `${streams.count} Streams`) || `${streams.count} Stream`)
      case LiveEventStatus.Concluded:
        return event.replay_video_count !== null && event.replay_video_count > 1
          ? `${event.replay_video_count} Replays`
          : null
      default:
        return null
    }
  } else {
    return null
  }
}

const checkForActiveStreams = (streamList: readonly StreamListItemLite[]): number => {
  return streamList.filter(stream => stream.stream_active).length
}
